export const interests = {
    productDevelopment: 'Product development',
    consulting: 'Consulting',
    somethingElse: 'Something else',
};

export const sources = {
    web: 'Web (Google)',
    recommendation: 'Recommendation',
    clutch: 'Clutch',
    socialNetworks: 'Social networks',
    other: 'Other',
};

export const budgetInts = {
    en: {
        lowest: 20000,
        low: 40000,
        high: 40001,
    },
    de: {
        lowest: 20000,
        low: 40000,
        high: 40001,
    },
    cs: {
        lowest: 200000,
        low: 500000,
        medium: 1000000,
        high: 1000001,
    },
};

const formatNumber = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const createBudgets = locale => {
    const localeBudges = {};

    const currency = locale === 'cs' ? 'Kč' : 'EUR';

    Object.entries(budgetInts[locale]).forEach(([key, value]) => {
        if (key === 'high') {
            localeBudges[key] = `More than ${formatNumber(value)} ${currency}`;
        }
        localeBudges[key] = `Up to ${formatNumber(value)} ${currency}`;
    });

    return localeBudges;
};

export const budgets = {
    cs: createBudgets('cs'),
    en: createBudgets('en'),
    de: createBudgets('de'),
};

export const localeToMarket = {
    cs: 'CZ',
    de: 'DACH',
    en: 'Other',
};
